module.exports = __webpack_public_path__ + "img/reference59.7e2823bc.jpg";